import React, { useContext, useEffect, useState } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import queryString from 'query-string'
import {
  ResetPasswordResult,
  ResetPasswordInput,
  ApiError,
} from 'EstraSuppliers'
import { useMutate } from 'restful-react'

import { routes } from 'app/routes'
import { AuthenticationContext } from 'app/Contexts/AuthenticationProvider'
import { endpoints } from 'app/api/endpoints'
import { HeaderContext } from 'app/Contexts/HeaderProvider'
import styled from 'styled-components'
import { FormResetPassword } from './FormResetPassword'
import { Container } from 'app/components/ui/Container'

const initialValues = {
  password: '',
  passwordConfirmation: '',
}

export type ResetPasswordFormState = typeof initialValues

export const ResetPassword: React.FC = () => {
  const authCtx = useContext(AuthenticationContext)

  const headerCtx = useContext(HeaderContext)

  const { search } = useLocation()

  const { push } = useHistory()

  const goToDashboard = () => {
    push(routes.dashboard.makeUrl())
  }

  const [showConfirmation, setShowConfirmation] = useState(false)

  // GET TOKEN
  const queryObject = queryString.parse(search)
  const resetToken = queryObject.reset_token
    ? `${queryObject.reset_token}`
    : undefined

  // RESET PASSWORD MUTATION
  const {
    mutate: sendResetPasswordMutation,
    loading: isSubmittingMutation,
    error: apiError,
  } = useMutate<ResetPasswordResult, ApiError, {}, ResetPasswordInput>({
    verb: 'POST',
    path: endpoints.resetPassword,
  })

  const headerTitle = 'Reset Password'
  const headerSubtitle = 'Inserisci la tua nuova password.'

  useEffect(() => {
    if (headerCtx) {
      if (headerCtx) headerCtx.updateTitles(headerTitle, headerSubtitle)
      headerCtx.updateSubtitleVariant('login_signup')
    }
  }, [])

  if (!resetToken) {
    goToDashboard()
  }

  if (authCtx && authCtx.actor && authCtx.actor.id) {
    // user is logged already
    goToDashboard()
  }

  return (
    <ResetPasswordFormContainer>
      <FormResetPassword
        onResetPasswordRequest={(password, setSubmitting) => {
          sendResetPasswordMutation({
            token: resetToken,
            password,
          })
            .then(res => {
              if (res.status === 'ok') {
                setShowConfirmation(true)
              }
            })
            .catch(() => {
              setSubmitting(false)
            })
        }}
        isLoading={isSubmittingMutation}
        error={apiError}
        showConfirmation={showConfirmation}
      />
    </ResetPasswordFormContainer>
  )
}

const ResetPasswordFormContainer = styled(Container)`
  padding-top: 3rem;
  margin-bottom: 3rem;

  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: ${({ theme }) => theme.bp.tablet}) {
    max-width: 340px;
    margin-left: auto;
    margin-right: auto;
  }
`
